import {
  createBrand as publicCreateBrand,
  getBrand as publicGetBrand,
  updateBrand as publicUpdateBrand,
  deleteBrand as publicDeleteBrand,
  queryBrands as publicQueryBrands,
  typedQueryBrands as publicTypedQueryBrands,
  bulkCreateBrands as publicBulkCreateBrands,
  bulkUpdateBrands as publicBulkUpdateBrands,
  getOrCreateBrand as publicGetOrCreateBrand,
  bulkGetOrCreateBrands as publicBulkGetOrCreateBrands,
  bulkDeleteBrands as publicBulkDeleteBrands,
} from './stores-catalog-v3-brand-brands-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  BrandQuery,
  BrandsQueryBuilder,
  QueryBrandsOptions,
  typedQueryBrands as universalTypedQueryBrands,
} from './stores-catalog-v3-brand-brands-v-3.universal.js';
import { onBrandCreated as publicOnBrandCreated } from './stores-catalog-v3-brand-brands-v-3.public.js';
import { onBrandDeleted as publicOnBrandDeleted } from './stores-catalog-v3-brand-brands-v-3.public.js';
import { onBrandUpdated as publicOnBrandUpdated } from './stores-catalog-v3-brand-brands-v-3.public.js';

function customQueryBrands(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryBrandsOptions) =>
      publicQueryBrands(httpClient)(options),
    typedQueryFunction: (query: BrandQuery, options?: QueryBrandsOptions) =>
      publicTypedQueryBrands(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: BrandQuery,
    options?: QueryBrandsOptions
  ): ReturnType<typeof universalTypedQueryBrands>;
  function overloadedQuery(options?: QueryBrandsOptions): BrandsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: BrandQuery | QueryBrandsOptions,
    options?: QueryBrandsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createBrand: MaybeContext<
  BuildRESTFunction<typeof publicCreateBrand> & typeof publicCreateBrand
> = /*#__PURE__*/ createRESTModule(publicCreateBrand);
export const getBrand: MaybeContext<
  BuildRESTFunction<typeof publicGetBrand> & typeof publicGetBrand
> = /*#__PURE__*/ createRESTModule(publicGetBrand);
export const updateBrand: MaybeContext<
  BuildRESTFunction<typeof publicUpdateBrand> & typeof publicUpdateBrand
> = /*#__PURE__*/ createRESTModule(publicUpdateBrand);
export const deleteBrand: MaybeContext<
  BuildRESTFunction<typeof publicDeleteBrand> & typeof publicDeleteBrand
> = /*#__PURE__*/ createRESTModule(publicDeleteBrand);
export const bulkCreateBrands: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateBrands> &
    typeof publicBulkCreateBrands
> = /*#__PURE__*/ createRESTModule(publicBulkCreateBrands);
export const bulkUpdateBrands: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateBrands> &
    typeof publicBulkUpdateBrands
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateBrands);
export const getOrCreateBrand: MaybeContext<
  BuildRESTFunction<typeof publicGetOrCreateBrand> &
    typeof publicGetOrCreateBrand
> = /*#__PURE__*/ createRESTModule(publicGetOrCreateBrand);
export const bulkGetOrCreateBrands: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetOrCreateBrands> &
    typeof publicBulkGetOrCreateBrands
> = /*#__PURE__*/ createRESTModule(publicBulkGetOrCreateBrands);
export const bulkDeleteBrands: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteBrands> &
    typeof publicBulkDeleteBrands
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteBrands);
export const queryBrands: MaybeContext<
  BuildRESTFunction<typeof customQueryBrands> & typeof customQueryBrands
> = /*#__PURE__*/ createRESTModule(customQueryBrands);
/**
 * Triggered when a brand is created.
 */
export const onBrandCreated: BuildEventDefinition<typeof publicOnBrandCreated> &
  typeof publicOnBrandCreated = createEventModule(publicOnBrandCreated);
/**
 * Triggered when a brand is deleted.
 */
export const onBrandDeleted: BuildEventDefinition<typeof publicOnBrandDeleted> &
  typeof publicOnBrandDeleted = createEventModule(publicOnBrandDeleted);
/**
 * Triggered when a brand is updated.
 */
export const onBrandUpdated: BuildEventDefinition<typeof publicOnBrandUpdated> &
  typeof publicOnBrandUpdated = createEventModule(publicOnBrandUpdated);

export {
  RequestedFields,
  SortOrder,
  WebhookIdentityType,
} from './stores-catalog-v3-brand-brands-v-3.universal.js';
export {
  Brand,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateBrandRequest,
  CreateBrandResponse,
  GetBrandRequest,
  GetBrandResponse,
  UpdateBrandRequest,
  UpdateBrandResponse,
  DeleteBrandRequest,
  DeleteBrandResponse,
  QueryBrandsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryBrandsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkCreateBrandsRequest,
  BulkCreateBrandsResponse,
  BulkBrandsResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateBrandsRequest,
  MaskedBrand,
  BulkUpdateBrandsResponse,
  GetOrCreateBrandRequest,
  GetOrCreateBrandResponse,
  BulkGetOrCreateBrandsRequest,
  BulkGetOrCreateBrandsResponse,
  BulkDeleteBrandsRequest,
  BulkDeleteBrandsResponse,
  BulkDeleteBrandsResponseBulkBrandsResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  RecloneSiteRequest,
  RecloneSiteResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  BrandCreatedEnvelope,
  BrandDeletedEnvelope,
  BrandUpdatedEnvelope,
  GetBrandOptions,
  UpdateBrand,
  UpdateBrandOptions,
  QueryBrandsOptions,
  BrandsQueryResult,
  BrandsQueryBuilder,
  BrandQuerySpec,
  BulkCreateBrandsOptions,
  BulkUpdateBrandsOptions,
  GetOrCreateBrandOptions,
  BulkGetOrCreateBrandsOptions,
} from './stores-catalog-v3-brand-brands-v-3.universal.js';
export { utils } from './stores-catalog-v3-brand-brands-v-3.universal.js';
export {
  RequestedFieldsWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateBrandValidationErrors,
  BulkCreateBrandsValidationErrors,
  GetOrCreateBrandValidationErrors,
  CommonQueryWithEntityContext,
  BrandQuery,
} from './stores-catalog-v3-brand-brands-v-3.universal.js';
